import { AppDispatch } from "../../store";
import { eraseUserInfo } from "../../redux/modules/user/reducer";
import { killSessionCookie } from "../../redux/accessTokenManagerActions";
import { redirectToSigninPage } from "../../redux/redirectToSigninPage";

export const userClicksLogoutButton = () => async (
  dispatch: AppDispatch,
): Promise<void> => {
  await dispatch(killSessionCookie());
  dispatch(eraseUserInfo());
  dispatch(redirectToSigninPage());
};
